// import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigCoverGoProd from "./appConfigCoverGoProd.js"
import appConfigOnpremDev from "./appConfigOnpremDev.js"
import appConfigOnpremProd from "./appConfigOnpremProd.js"
import { COVERGO_SAAS_PROD } from "../consts.js"

const FUBON_ONPREM_DEV = {
	COVERGO_GRAPHQL: "http://10.43.51.10:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://10.43.51.10:32100/api/v1/files"
}

const FUBON_ONPREM_PROD = {
	COVERGO_GRAPHQL: "http://10.43.29.13:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://10.43.29.13:32100/api/v1/files"
}

const FUBON_ONPREM_DR = {
	COVERGO_GRAPHQL: "http://10.43.29.31:32100/graphql",
	COVERGO_FILE_SYSTEM: "http://10.43.29.31:32100/api/v1/files"
}

export const fubon = {
	"fubon-uat-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_SAAS_PROD },
	"10.43.51.10:32102": { appConfig: appConfigOnpremDev, envConfig: FUBON_ONPREM_DEV },
	"10.43.29.13:32102": { appConfig: appConfigOnpremProd, envConfig: FUBON_ONPREM_PROD },
	"10.43.29.31:32102": { appConfig: appConfigOnpremProd, envConfig: FUBON_ONPREM_DR }
}
